import { render, staticRenderFns } from "./p01.vue?vue&type=template&id=89adf02e&scoped=true&"
import script from "./p01.vue?vue&type=script&lang=js&"
export * from "./p01.vue?vue&type=script&lang=js&"
import style0 from "./p01.vue?vue&type=style&index=0&id=89adf02e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89adf02e",
  null
  
)

export default component.exports